import { render, staticRenderFns } from "./OrderBar.vue?vue&type=template&id=45b22966"
import script from "./OrderBar.vue?vue&type=script&lang=js"
export * from "./OrderBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports